import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import "../../../ProfileCard.css"
const Profileprofcard = ({ name, desc, follower, profile_pic, profileid }) => {
  let history = useHistory();
  function Profile(y) {
    localStorage.setItem(
      "profileid",
      JSON.stringify({ profileid: y })
    );
    console.log(y)
    history.push("/user");
  }
  return (
    <>
      <div className="profcard">
        <div className="profimg" style={{ backgroundImage: `url(${profile_pic})` }} onClick={() => { Profile(profileid) }} >
          {/* <img src={profile_pic} /> */}
        </div>
        <div className="infos">
          <div className="nameprof">
            <h2 onClick={() => { Profile(profileid) }} >{name}</h2>
          </div>
          <p className="text2" style={{ cursor: "text" }}>
            {desc}
          </p>
          {/* <div className="links">
        <button onClick={()=>{Profile(profileid)}} className="view">View profile</button>
      </div> */}
          <button onClick={() => { Profile(profileid) }} className="view">View profile</button>
          {/* <ul className="stats">

            <li>
              <div className="links">
                <button onClick={() => { Profile(profileid) }} className="view">View profile</button>
              </div>
            </li>

          </ul> */}

        </div>
      </div>
      <hr className="line" />
    </>
  )
};
export default Profileprofcard;
